/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useContext, useMemo } from "react";
import { FloatingPanelManager } from "./FloatingPanelManager";

export interface IFloatingPanelContext {
	manager: FloatingPanelManager;
}

export const FloatingPanelContext = React.createContext<IFloatingPanelContext>(null);

export function useFloatingPanelContext(): IFloatingPanelContext {
	return useContext(FloatingPanelContext);
}

export interface IFloatingPanelContextProviderProps {
	manager: FloatingPanelManager;
}

export const FloatingPanelContextProvider: React.FC<IFloatingPanelContextProviderProps> = ({
	children,
	manager
}) => {
	const contextValue = useMemo<IFloatingPanelContext>(() => ({ manager }), [ manager ]);

	return <FloatingPanelContext.Provider value={contextValue}>{children}</FloatingPanelContext.Provider>;
};
